// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';
import { BehaviorSubject } from 'rxjs';
import { saveAs } from 'file-saver';
import { PlotSeedLandingReleaseFilterVM } from '../../models/plot-seed-landing-release-filterVM';

@Injectable()
export class PlotSeedReleaseService {
  public redirectFrom: any;
  private filters: any;
  oldFilters:PlotSeedLandingReleaseFilterVM = new PlotSeedLandingReleaseFilterVM();
  plotSeedOrderHeaderId: BehaviorSubject<number>;
  constructor(public configService: ConfigService,
    public networkService: NetworkService) {
    this.plotSeedOrderHeaderId = new BehaviorSubject(0);
  }
  public setPlotSeedOrderId(value: number) {
    this.plotSeedOrderHeaderId.next(value);
  }
  public checkCreateAccessForPlotSeed() {
    return this.networkService.getRequest(this.configService.checkCreateAccessForPlotSeed());
  }
  public getPlotSeedProductLines() {
    return this.networkService.getRequest(this.configService.getPlotSeedProductLines());
  }
  public getPlotSeedLandingData(filter) {
    return this.networkService.postRequest(this.configService.getPlotSeedLandingData(), filter);
  }
  public getPlotSeedOrderItemData(orderHeaderId) {
    return this.networkService.getRequest(this.configService.getPlotSeedOrderItemDetailData() + '?orderHeaderId=' + orderHeaderId);
  }

  public getPlotSeedReleaseOrderHeaderData() {
    return this.networkService.getRequest(this.configService.getPlotSeedReleaseOrderHeaderData());
  }
  public getPlotSeedShipToAscAccounts(salesManager: number, productLine: string) {
    return this.networkService.getRequest(this.configService.getPlotSeedOrderShipToData() + '?salesManager=' + salesManager + '&productLineId=' + productLine);
  }
  public getPlotSeedDeliverTo(accountNumber, parentAccountNumber) {
    return this.networkService.getRequest(this.configService.getPlotSeedDeliverTo() + '?accountNumber=' + accountNumber + '&parentAccountNumber=' + parentAccountNumber);
  }
  public getPlotSeedDetailsData(filter) {
    return this.networkService.postRequest(this.configService.getPlotSeedDetailsData(), filter);
  }
  public getPlotSeedOrderNumbers(salesManager, shipToaccount, productLine) {
    return this.networkService.getRequest(this.configService.getPlotSeedOrderNumbersData() + '?salesManagerAccount=' + salesManager + '&shipToAccount=' + shipToaccount + '&productLineId=' + productLine);
  }
  public getPlotSeedSalesManagerAccounts(productLine) {
    return this.networkService.getRequest(this.configService.getPlotSeedOrderSalesManagerData() + '?productLineId=' + productLine);
  }
  public placePlotSeedOrder(order) {
    return this.networkService.postRequest(this.configService.placePlotSeedOrder(), order);
  }
  public getMaturityData() {
    return this.networkService.getRequest(this.configService.getPlotSeedMaturityData());
  }
  public exportToExcel(dashboardFilter: any) {
    return this.networkService.postRequest(this.configService.exportToExcelPlotSeedDataUrl, dashboardFilter);
  }
  public getPlotSeedReleaseData(data) {
    return this.networkService.postRequest(this.configService.getPlotSeedReleaseData(), data);
  }
  public getPalletAndSeedWeight(data: any) {
    return this.networkService.postRequest(this.configService.getPlotSeedPalletAndSeedWeightData(), data);
  }
  public getItemAvailabilityByLot(data: any) {
    return this.networkService.postRequest(this.configService.getPlotSeedItemAvailabilityByLotData(), data);
  }
  public getReleaseOrderData(filter) {
    return this.networkService.postRequest(this.configService.getPlotSeedReleaseOrderData(), filter);
  }
  public getPlotSeedReleaseJDESyncData(filter) {
    return this.networkService.postRequest(this.configService.getPlotSeedReleaseJDESyncData(), filter);
  }
  public getReleaseOrderErrorData(filter) {
    return this.networkService.postRequest(this.configService.getPlotSeedReleaseOrderErrorData(), filter);
  }
  public exportReviewRelease(filter: any) {
    return this.networkService.postRequest(this.configService.exportPlotSeedReviewReleaseData(), filter);
  }
  setOldFilters(value: PlotSeedLandingReleaseFilterVM) {
    this.oldFilters = value;
  }
  getOldFilters() {
    return this.oldFilters;
  }
  // Convert b64 to BLOB
  public b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  public base64toFile(base64String, contentType, fileName) {
    const blob = this.b64toBlob(base64String, contentType, 550);
    saveAs(blob, fileName);
  }
  public downloadPdfForMobile(summaryResult) {
    return this.networkService.postRequest(this.configService.GetPlotSeedOrderPdfData(), summaryResult);
  }
  public sendBaseDate(filters) {
    return this.networkService.postRequest(this.configService.PlotSeedPostFileForPdf(), filters);
  }

  // Place single JDE order
  public placeJDEOrder(data: any) {
    return this.networkService.postRequest(this.configService.PlotSeedPlaceJDEOrderUrl(), data);
  }
}
